<template>
    <div>
        <dot-loader class="loader" v-if="!allFinished"></dot-loader>
        <div v-show="allFinished">
            <date-selection-container>
                <MissingDeals></MissingDeals>
            </date-selection-container>
            <deal-table @loadingFinished="tableFinished = true"></deal-table>
        </div>
    </div>
</template>

<script>
import DealTable from "../DealTable";
import DateSelectionContainer from "../../components/datePicker/DateSelectionContainer";
import MissingDeals from "@/views/AllDeals/MissingDeals";

export default {
    name: "AllDeals",
    components: {MissingDeals, DateSelectionContainer, DealTable},
    data() {
        return {
            showColumnSettings: false,
            tableFinished: false
        }
    },
    created() {
        this.$store.commit('presets/resetCurrentPreset');
    },
    mounted() {
        this.fetchPresets();
        this.fetchMissingDealIds();
    },
    computed: {
        displayColumns() {
            let ret = this.$store.getters['columns/columns'];
            let cols = [];
            for (let i = 0; i < ret.length; i++) {
                cols.push({
                    width: '33%',
                    label: ret[i]['display_name'],
                    name: ret[i]['name']
                });
            }
            return cols;
        },
        allFinished() {
            return this.tableFinished;
        },
        vuexState() {
            return this.$store.state.presets;
        },
        currentPreset() {
            return this.vuexState.currentPreset;
        },
        presets() {
            return this.vuexState.presets;
        },
        currentPresetColumns() {
            return this.vuexState.currentPresetColumns;
        }
    },
    methods: {
        async fetchPresets() {
            await this.$store.dispatch('presets/fetch', true);
        },
        async fetchMissingDealIds() {
            await this.$store.dispatch('deals/fetchMissingDealIds');
        },
        async fetchCurrPreset(id) {
            await this.$store.dispatch('presets/setCurrentPreset', id);
        },
        selectPreset(val) {
            this.fetchCurrPreset(val.id).then(() => {
                console.log('preset selected')
            });
        }
    }
}
</script>

<style scoped lang="scss">
.topAction {
    display: inline-block;
    float: right;
    padding-left: 1rem;
}

.icon {
    padding: .9rem;
}

.columnButton {
    display: inline-block;
    float: right;
}

.section {
    display: block;
    margin-bottom: 1rem;
    width: 100%;
    overflow-y: auto;
}

.loader {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 400px;
}
</style>